/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { RoutingSolutionDtoModel, RoutingSolutionMetadata, RoutingSolutionVoModel } from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RoutingSolutionResourceService extends AbstractResourceService<
  RoutingSolutionVoModel,
  RoutingSolutionDtoModel,
  unknown,
  unknown
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('routingSolutionUrl'),
      RoutingSolutionVoModel,
      RoutingSolutionDtoModel
    );
  }

  getRoutingSolutionForShipmentGroup(
    shipmentGroupUuid: string
  ): Observable<JsonApiResource<RoutingSolutionVoModel[], JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<RoutingSolutionVoModel[], JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/${shipmentGroupUuid}`);
  }

  getTemplateFromSegment(
    segmentUuid: string
  ): Observable<JsonApiResource<RoutingSolutionDtoModel, RoutingSolutionMetadata>> {
    return this.httpClient?.get(`${this.url}/new/template/segment/${segmentUuid}`).pipe(this.getDtoMapper());
  }

  saveRoutingSolution(resource: RoutingSolutionDtoModel, uniqueSegmentUuid: string | null): Observable<RoutingSolutionVoModel> {
    const url = uniqueSegmentUuid ? `${this.url}?uniqueSegmentUuid=${uniqueSegmentUuid}` : `${this.url}`;
    return this.httpClient?.post(url, resource, { headers: this.headers }).pipe(this.getDtoMapper());
  }

  getTemplateFromOrder(orderUuid: string) {
    return this.httpClient?.get(`${this.url}/new/template/order/${orderUuid}`).pipe(this.getDtoMapper()) as Observable<
      JsonApiResource<RoutingSolutionDtoModel, RoutingSolutionMetadata>
    >;
  }
}
